export { default } from './PropertyLowRatesCalendarContainerMobile';
